import apiClient from "@/config/api";

const actions = {
  createTicket({ commit }, ticketData) {
    try {
      //   commit("SET_LOADING", true);
      return new Promise((resolve, reject) => {
        apiClient
          .post("/tickets-public", ticketData)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
            console.error("API Error:", err);
          });
        // commit("SET_TICKET", ticketData);
      });
    } finally {
      commit("SET_LOADING", false);
    }
  },
};
export default actions;
